<div echarts [options]="options"></div>